export const DESKTOP_PCM_MIME_PREFIX = "application/x-recall-pcm";
export const DESKTOP_PCM_SAMPLE_RATE = 16000;
export const DESKTOP_PCM_CHANNELS = 1;
export const DESKTOP_PCM_BITS_PER_SAMPLE = 16;

export function desktopPcmMime(): string {
  return `${DESKTOP_PCM_MIME_PREFIX};sr=${DESKTOP_PCM_SAMPLE_RATE};ch=${DESKTOP_PCM_CHANNELS};bits=${DESKTOP_PCM_BITS_PER_SAMPLE}`;
}

export function isDesktopPcmBlob(blob: Blob): boolean {
  return typeof blob?.type === "string" && blob.type.startsWith(DESKTOP_PCM_MIME_PREFIX);
}
